import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import { useTranslation } from "next-i18next";

const TestimonialsDemoPage = () => {
    const { t } = useTranslation("common");
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <div className={'mw-carousel demo-request'}>
                <Carousel responsive={responsive} infinite={true}>
                    {/*<div>*/}
                    {/*    <div className={'mw-testimonial'}>*/}
                    {/*        <div className={'content'}>*/}
                    {/*            <p>We migrated from Datadog to Middleware because we absolutely love their unified*/}
                    {/*                view. It's such a simple but incredibly useful tool. This among other features*/}
                    {/*                made it a no brainer for us to migrate. We monitor our logs, metrics, and traces*/}
                    {/*                at a very affordable cost.</p>*/}
                    {/*        </div>*/}
                    {/*        <div className={'author-details cliff'}>*/}
                    {/*            <div className={'client-logo'}>*/}
                    {/*                <img src={"/images/puresend.svg"}*/}
                    {/*                     alt={"Puresend"} width={200} height={200} className={"black-white"}/>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <div className={'author-name'}>*/}
                    {/*            <p>Cliff</p>*/}
                    {/*            <p className={"author-designation"}>Owner</p>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div>
                        <div className={'mw-testimonial'}>
                            <div className={'content'}>
                                <p>{t("demoRequest.testimonials.testimonial1.content")}</p>
                            </div>
                            <div className={'author-details prajwal'}>
                                <div className={'client-logo'}>
                                    <img src={"/images/trusted-company/mindorigin.svg"}
                                         alt={"MindOrigin"} width={160} height={160} className={"black-white"} loading="lazy" decoding="async"/>
                                </div>
                            </div>
                            <div className={'author-name'}>
                                <p>{t("demoRequest.testimonials.testimonial1.authorName")}</p>
                                <p className={"author-designation"}>{t("demoRequest.testimonials.testimonial1.authorDesignation")}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={'mw-testimonial'}>
                            <div className={'content'}>
                                <p>{t("demoRequest.testimonials.testimonial2.content")}</p>
                            </div>
                            <div className={'author-details artem'}>
                                <div className={'client-logo'}>
                                    <img src={"/images/mw-dardeen.svg"}
                                         alt={"Dardeen"} width={160} height={160} className={"black-white"} loading="lazy" decoding="async"/>
                                </div>
                            </div>
                            <div className={'author-name'}>
                                <p>{t("demoRequest.testimonials.testimonial2.authorName")}</p>
                                <p className={"author-designation"}>{t("demoRequest.testimonials.testimonial2.authorDesignation")}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={'mw-testimonial'}>
                            <div className={'content'}>
                                <p>{t("demoRequest.testimonials.testimonial3.content")}</p>
                            </div>
                            <div className={'author-details ashot'}>
                                <div className={'client-logo'}>
                                    <img src={"/images/mw-cloudchip.svg"}
                                         alt={"Cloudchip"} width={160} height={160} className={"black-white"} loading="lazy" decoding="async"/>
                                </div>
                            </div>
                            <div className={'author-name'}>
                                <p>{t("demoRequest.testimonials.testimonial3.authorName")}</p>
                                <p className={"author-designation"}>{t("demoRequest.testimonials.testimonial3.authorDesignation")}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={'mw-testimonial'}>
                            <div className={'content'}>
                                <p>{t("demoRequest.testimonials.testimonial4.content")}</p>
                            </div>
                            <div className={'author-details tatevik'}>
                                <div className={'client-logo'}>
                                    <img src={"/images/mw-activeloop.svg"}
                                         alt={"Activeloop"} width={160} height={160} className={"black-white"} loading="lazy" decoding="async"/>
                                </div>
                            </div>
                            <div className={'author-name'}>
                                <p>{t("demoRequest.testimonials.testimonial4.authorName")}</p>
                                <p className={"author-designation"}>{t("demoRequest.testimonials.testimonial4.authorDesignation")}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={'mw-testimonial'}>
                            <div className={'content'}>
                                <p>{t("demoRequest.testimonials.testimonial5.content")}</p>
                            </div>
                            <div className={'author-details akshat'}>
                                <div className={'client-logo'}>
                                    <img src={"/images/client-logo/trademarkia.svg"}
                                         alt={"Trademarkia"} width={160} height={160} className={"black-white"} loading="lazy" decoding="async"/>
                                </div>
                            </div>
                            <div className={'author-name'}>
                                <p>{t("demoRequest.testimonials.testimonial5.authorName")}</p>
                                <p className={"author-designation"}>{t("demoRequest.testimonials.testimonial5.authorDesignation")}</p>
                            </div>
                        </div>
                    </div>
                </Carousel>
        </div>
    );
}

export default TestimonialsDemoPage;
